<template>
    <div class="ns-toast_container" :opened="opened" :theme="theme" :type="type" :duration="duration" :icon="icon" :no-icon="noIcon" :show-close-icon="showCloseIcon">
        <div class="toast__scrim" @click="hide"></div>
        <section class="toast">
            <ns-icon icon-name="icon-close" class="toast__icon--close" @click="hide"></ns-icon>
            <div class="message_action_container">
                <div class="title_message" :class="[hideAction ? 'hide_action' : '']">
                    <div class="exclusive_title">
                        <ns-icon icon-name="icon-exclusive-offer" size="icon-lg"></ns-icon>
                        <span>{{exclusiveOfferTitle}}</span>
                    </div>
                    <p>{{message}}</p>
                </div>
                <button v-if="!hideAction" class="secondary-outline message_action" v-class="{fluid: ($mq !== 'desktop' && $mq !== 'desktopHD')}" @click="_messageAction">{{actionName}}</button>
                <button v-if="!hideSecondaryAction" class="primary-ghost secondary_message_action" :fluid="($mq !== 'desktop' && $mq !== 'desktopHD')" @click="_secondaryMessageAction">{{secondaryActionName}}</button>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from 'vue';
import VueMq from 'vue-mq';
import {events, UrlService} from '@nuskin/ns-util';
import {UserService} from '@nuskin/ns-account';
import {NsIcon} from '@nuskin/ns-icon';

Vue.use(VueMq, {
    breakpoints: {
        mobile: 375,
        phablet: 768,
        tablet: 1024,
        desktop: 1440,
        desktopHD: Infinity
    }
});

const nsToastVue = {
    name: "ExclusiveOfferToast",
    components: {NsIcon},
    props: {
        /**
        * How long fleeting toasts should stay on the screen
        */
        duration: {
            type: String,
            default: "3200"
        },
        /**
        * The icon that should be displayed on the left of the toast. Takes a string representing the set and id of the icon
        */
        icon: {
            type: String,
            default: 'icon-info-filled'
        },
        /**
        * Hide the icon displayed on the left of the toast
        */
        noIcon: {
            type: Boolean
        },
        /**
        * Determines how the toast should look. Options include: none (default), 'information', 'success', 'warning', 'error'
        */
        theme: {
            type: String
        },
        /**
        * Determines the type of toast. Options include: 'fleeting' (default), 'persistent', 'cta'
        */
        type: {
            type: String,
            default: 'fleeting'
        },
        /**
        * Used to show the close icon on the toast
        */
        showCloseIcon: {
            type: Boolean
        },
        /**
        * Used to register toast to an event to show and hide
        */
        toastEventName: String,
        /**
        *
        */
        custom: Boolean,
        /**
         * Exclusive offer title
         */
        exclusiveOfferTitle: String,
        /**
         * Message to be displayed
         */
        message: String,
        /**
         * URL to link too when action button clicked
         */
        actionurl: String,
        /**
         * URL for secondary action
         */
        secondaryactionurl: String,
        /**
         * Text to display on button
         */
        actionName: String,
        /**
         * Text to display on secondary action
         */
        secondaryActionName: String,
        /**
         * use login to perform login instead of url redirect
         */
        actionType: {
            type: String,
            default: ""
        },
        /**
         * Flag to use an event to perform secondary action
         */
        useEventForSecondaryAction: Boolean
    },
    data: function() {
        return {
            /**
            * Indicated the opened or closed state of the toast. You can also set the attribute to open the toast.
            */
            opened: false,
            /**
             * Used to go to a specific URL if override specified
             */
            secondaryActionPDPSKU: ""
        }
    },
    computed: {
        hideAction: function() {
            if (this.actionType === "login" && UserService.isLoggedIn()) {
                return true;
            }

            return false;
        },
        hideSecondaryAction: function() {
            return !this.secondaryActionName && !this.secondaryactionurl;
        }
    },
    mounted: function() {
        events.subscribe(events.shop.SHOW_EXCLUSIVE_OFFER_DETAILS, item => {
            if (item && item.sku) {
                this.secondaryActionPDPSKU = item.sku;
            }
        });

        this.registerEvents();
    },
    methods: {
        /**
        * Display the toast
        */
        show() {
            this.opened = true;
            if (this.type === 'fleeting' || !this.type) {
                setTimeout(() => {
                    this.hide();
                }, Number(this.duration));
            }
        },
        /**
        * Hide the toast
        */
        hide() {
            this.opened = false;
        },
        /**
        * Facade method for show()
        */
        open() {
            this.show()
        },
        /**
        * Facade method for hide()
        */
        close() {
            this.hide()
        },
        /**
        * Toggle the display of the toast
        */
        toggle() {
            this.opened ? this.hide() : this.show();
        },
        registerEvents() {
            if (this.toastEventName) {
                events.subscribe(this.toastEventName, () => {
                    this.show();
                });
            }

            // need to close the toast if the cta is clicked
            $("#ctaWrapper").click((e) => {
                if(this.type === 'cta') {
                    this.hide();
                }
            });
        },
        /**
         * Used to either login or redirect on action click
         * @private
         */
        _messageAction: function() {
            if (this.actionType === "login") {
                events.publish(events.authentication.REQUEST_FOR_LOGIN);
            } else {
                window.location = actionurl;
            }
        },
        _secondaryMessageAction: function() {
            if (this.useEventForSecondaryAction || !this.secondaryactionurl) {
                window.location = UrlService.getAemLocaleUrl() + "products/product." + this.secondaryActionPDPSKU + ".html";
            } else {
                window.location = this.secondaryactionurl;
            }
        }
    },
    watch: {
        secondaryActionName() {
            this.registerEvents();
        }
    }
}

export default nsToastVue;
</script>

<style lang="scss" scoped>
    @use "sass:map";
    @use '~@nuskin/ns-core-styles/src/scss/global.mixins';
    @use '~@nuskin/ns-core-styles/src/scss/colors';
    @use '~@nuskin/ns-core-styles/src/scss/typographyVariables';
    @use '~@nuskin/ns-core-styles/src/scss/other';

    * { box-sizing: border-box; }

    .toast {
        visibility: hidden;
        display: flex;
        align-items: center;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        transform: translateY(120px);
        color: map.get(colors.$themeColors, color-primary-text);
        font-family: map.get(typographyVariables.$typography, font-family-primary);
        border-top: 2px solid map.get(colors.$themeColors, color-interactive-7);
        background-color: #ffffff;
        opacity: 0;
        transition: map.get(other.$otherUtils, global-transition);
        z-index: map.get(other.$otherUtils, z-modal);
    }
    // .ns-toast_container[custom] .toast {
    //     justify-content: center;
    //     width: 100%;
    // }
    .ns-toast_container[opened] .toast {
        visibility: visible;
        opacity: 1;
        transform: translateY(0);
    }
    .toast .responsive-container {
        padding-top: 30px;
        padding-bottom: 30px;
        position: relative;
    }
    .responsive-container__inner-container {
        display: grid;
        grid-gap: 20px;
    }
    .toast__icon--status {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }
    .toast__content {
        flex: 1;
    }
    .toast__content--left {
        display: flex;
        align-items: center;
    }
    .toast__cta-section > * {
        text-transform: capitalize;
        @include global.a-base();
    }
    .toast__icon--close {
        cursor: pointer;
        position: absolute;
        top: 15px;
        right: 15px;
        height: 18px;
        width: 18px;
    }
    .ns-toast_container[type="fleeting"] .toast__scrim {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: map.get(other.$otherUtils, z-modal);
        background-color: map.get(other.$otherUtils, global-overlay-background);
        opacity: 0;
        visibility: hidden;
        transition: map.get(other.$otherUtils, global-transition);
    }
    // .ns-toast_container[custom] {
    //     display: none;
    // }
    // .ns-toast_container[custom][opened] {
    //     display: block;
    // }
    .ns-toast_container .custom {
        width: 100%;
    }
    .ns-toast_container[no-top-border] .toast {
        border-top: 0
    }
    // .ns-toast_container[custom] .responsive-container {
    //     display: none;
    // }
    .ns-toast_container[theme="information"] .toast {
        border-color: map.get(colors.$themeColors, color-information);
    }
    .ns-toast_container[theme="success"] .toast {
        border-color: map.get(colors.$themeColors, color-progress);
    }
    .ns-toast_container[theme="warning"] .toast {
        border-color: map.get(colors.$themeColors, color-warning);
    }
    .ns-toast_container[theme="error"] .toast {
        border-color: map.get(colors.$themeColors, color-error);
    }
    .ns-toast_container[theme="exclusive"] .toast {
        border-color: map.get(colors.$themeColors, color-interactive-3);
    }
    .message_action_container {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: auto;
        background-color: rgba(147,0,147,0.06);
        padding: 14px 16px;
        padding-top: 20px;

        p {
            margin-top: 13px;
            color:  map.get(colors.$themeColors, color-primary-text);
            @include global.p-medium();
        }

        .message_action {
            margin-top: 7px;
        }

        .secondary_message_action {
            margin-top: 17px;
        }

        .hide_action {
            flex-direction: row !important;
            justify-content: space-between;
            width: 100%;
        }
    }
    @media (min-width: 768px) {
        .responsive-container__inner-container{
            max-width: 600px;
            margin: 0 auto;
            grid-auto-flow: column;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 30px;
        }
    }
    @media (min-width: 1024px) {
        .message_action_container {
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 10px 17px;
            padding-top: 15px;

            p {
                max-width: 313px;
            }

            .title_message {
                display: flex;
                flex-direction: column;
            }

            .hide_action {
                p {
                    margin-top: 0;
                }
            }

            ns-button {
                position: absolute;
                right: 15px;
            }
        }
        .ns-toast_container {
            .toast{
                transform: translateY(120px);
                min-height: 95px;
            }
            .custom {
                min-height: 95px;
            }
        }
        .ns-toast_container[opened] .toast {
            transform: translateY(0);
        }
    }
    .ns-toast_container[no-icon] .toast__icon--status,
    .ns-toast_container:not([show-close-icon]) .toast__icon--close {
        display: none;
    }

</style>
